export default __webpack_public_path__ + "static/media/marker_yellow.378d8bbe.svg";